/**
 * RentedBadge
 *
 * Yellow pill rendered on rows/metrics the Org sees via a Creator
 * assignment (UPDATE.md §8.3, §11.x). Mirrors GigBoostBadge in shape
 * but signals borrowed rather than boosted data. Shows the source
 * Creator and optional days-remaining countdown:
 *
 *   RENTED · from Marko N · 41 days left
 *
 * Reusable across Audience tables, Insights cards, and anywhere a
 * `provenance.kind === 'rented'` row is rendered.
 */

import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './RentedBadge.module.css';

const RentedBadge = props => {
  const { className, creatorName, daysRemaining } = props;

  const hasCreator = !!creatorName;
  const hasDays = typeof daysRemaining === 'number' && daysRemaining >= 0;

  return (
    <span className={classNames(css.root, className)}>
      <span className={css.label}>
        <FormattedMessage id="RentedBadge.label" />
      </span>
      {hasCreator ? (
        <span className={css.divider} aria-hidden>·</span>
      ) : null}
      {hasCreator ? (
        <span className={css.creator}>
          <FormattedMessage
            id="RentedBadge.fromCreator"
            values={{ name: creatorName }}
          />
        </span>
      ) : null}
      {hasDays ? (
        <span className={css.divider} aria-hidden>·</span>
      ) : null}
      {hasDays ? (
        <span className={css.days}>
          <FormattedMessage
            id="RentedBadge.daysLeft"
            values={{ count: daysRemaining }}
          />
        </span>
      ) : null}
    </span>
  );
};

RentedBadge.defaultProps = {
  className: null,
  creatorName: null,
  daysRemaining: null,
};

RentedBadge.propTypes = {
  className: string,
  creatorName: string,
  daysRemaining: number,
};

export default RentedBadge;
